// extracted by mini-css-extract-plugin
export default {"resetPasswordConfirmationContainer":"QLhYR0","resetPasswordConfirmationHeader":"fRIRmS","resetPasswordConfirmationContent":"IDxIA1","resetPasswordConfirmationBody":"UX7xzo"};